import { Stack } from "@mui/material";
import Warning from "assets/noDataWarning.png";
import Typography from "../Typography";
import "./NoDataBanner.scss";

interface Props {
  noDataMessage?: String;
  bannerTypeTable?: boolean;
  bannerTheme?: String;
}
const NoDataBanner = (props: Props) => {
  const { noDataMessage = "No Results", bannerTypeTable = false, bannerTheme = "light" } = props;
  const noDataBannerWidth = bannerTypeTable ? "no-data-banner-full-width" : "no-data-banner-custom-width";
  const bannerColorClass = bannerTheme === "light" ? "no-data-bg-color-light" : "no-data-bg-color-dark ";

  return (
    <Stack className={`no-data-banner-component ${noDataBannerWidth} ${bannerColorClass}`}>
      <img src={Warning} alt="No Data Warning" className="no-data-banner-icon" />
      <Typography variant="body2" className="no-data-banner-text">
        {noDataMessage}
      </Typography>
    </Stack>
  );
};

export default NoDataBanner;
